import React, { useCallback } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import AlertsComponent from 'components/Alert/AlertsComponent';
import { InsuranceOffer } from 'types/Product';
import { IconBrandProtect } from '@tvg/fuse/icon/all';
import { IconElement } from '@tvg/fuse/icon-element';
import { Link } from '@tvg/fuse/link';
import { Typography } from '@tvg/fuse/typography';

import { getSite } from 'context/SiteContext';
import { InsuranceNotification } from './InsuranceNotification/InsuranceNotification';
import { InsuranceSelector } from './InsuranceSelector/InsuranceSelector';
import { InsuraceDescription } from './InsuranceDescription/InsuranceDescription';
import styles from './Insurance.module.css';

export function Insurance() {
  const {
    selectedSku,
    setCheckItsRightDialog,
    setSelectedInsurance,
    insuranceError,
    selectedInsurance,
    selectedSkuInsuranceContent,
    setFindOutMore,
    skus,
  } = useSelectedSkuContext();

  const firstInsuranceSKU = skus.find((sku) => sku.insuranceOffers && sku.insuranceOffers);

  const notificationTitle =
    firstInsuranceSKU?.insuranceOffers &&
    firstInsuranceSKU?.insuranceOffers[0]?.offer?.productDescription.replace(' Monthly', '');

  const title =
    selectedSku?.insuranceOffers && selectedSku?.insuranceOffers[0]?.offer?.productDescription.replace(' Monthly', '');

  const handleIfItsRightOpen = (option: InsuranceOffer | null) => {
    setSelectedInsurance(option);
    setCheckItsRightDialog(true);
  };

  const handleFindOutMore = () => {
    setFindOutMore(true);
    setCheckItsRightDialog(true);
  };

  const handleNoInsuranceSelect = useCallback(() => {
    setSelectedInsurance('No insurance');
  }, []);

  const covered =
    selectedSku &&
    selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[2].find((item) =>
      Object.keys(item).includes('bulletText'),
    );
  const site = getSite() === 'littlewoods' ? 'Littlewoods' : 'Very';
  if (selectedSku && !selectedSku.insuranceOffers) return null;
  if (selectedSku && selectedSku.insuranceOffers && selectedSkuInsuranceContent) {
    return (
      <div className={styles.container} id="insurance-container" data-testid="insurance-container">
        <div className={styles.titleRow}>
          <div className={styles.iconContainer}>
            <IconElement
              icon={<IconBrandProtect />}
              responsiveSize="small"
              dataTestId="insurance-title-icon"
              srLabel="Insurance"
            />
          </div>
          <Typography className={styles.titleText} size="1" tag="p" dataTestId="insurance-component-title">
            {selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[0][0].text ||
              selectedSkuInsuranceContent?.insuranceContent.pdpInsuranceDescription[0][0].title}
          </Typography>
        </div>
        <InsuraceDescription
          covered={covered?.bulletText}
          description={selectedSkuInsuranceContent.insuranceContent.pdpInsuranceDescription[1][0].text}
          boldDescription={selectedSkuInsuranceContent.insuranceContent.pdpInsuranceDescription[1][1].text}
        />
        <Link
          className={styles.findOutMore}
          isButton
          onClick={() => handleFindOutMore()}
          size="medium"
          dataTestId="insurance-find-out-more"
        >
          {`Find out more about ${site} ${title?.split('-')[0].trimEnd()}`}
        </Link>
        {insuranceError && <AlertsComponent errorMessage="Please select an insurance option." />}
        <InsuranceSelector
          options={selectedSku.insuranceOffers}
          handleSelectedInsurance={handleIfItsRightOpen}
          handleNoInsuranceSelect={handleNoInsuranceSelect}
          selectedInsurance={selectedInsurance}
          skuId={selectedSku.itemNumber}
        />
      </div>
    );
  }
  return (
    <div className={styles.container} id="insurance-container">
      <InsuranceNotification title={`${site} ${notificationTitle} Insurance`} />
    </div>
  );
}

export default Insurance;
